import { render, staticRenderFns } from "./ProTag.vue?vue&type=template&id=c97930bc&scoped=true"
import script from "./ProTag.vue?vue&type=script&lang=js"
export * from "./ProTag.vue?vue&type=script&lang=js"
import style0 from "./ProTag.vue?vue&type=style&index=0&id=c97930bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97930bc",
  null
  
)

export default component.exports